import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import SimpleDataTable from "lib/components/common/simple-data-table";
import useTherapies from "lib/hooks/useTherapies";
import TherapyDetails from "./therapy-details";
import LoadingBox from "lib/components/common/loading-box";
import { DMSServices } from "lib/services/document-services";
import { THERAPIES_COLUMNS } from "lib/constants/table-columns";

const Therapies = () => {
  const [selectedTherapy, setSelectedTherapy] = useState<Therapy>(null);
  const {
    therapies,
    getTherapies,
    loading,
    error,
    updateTherapy,
    deleteTherapy,
    addTherapy,
    getTherapyImage,
    setTherapyImage,
    resetError,
  } = useTherapies();

  useEffect(() => {
    getTherapies();
  }, []);

  const handleAddTherapy = async (therapy: Therapy) => {
    addTherapy(therapy, (newTherapy) => {
      const addedTherapy = newTherapy?.[0] as Therapy;
      setTherapyImage(addedTherapy.id, therapy.image, (url) => {
        setSelectedTherapy(null);
        getTherapies();
      });
    });
  };

  const handleUpdateTherapy = (therapy: Therapy) => {
    console.log(therapy);
    updateTherapy(therapy, (newTherapy) => {
      if (therapy.image) {
        const updatedTherapy = newTherapy?.[0] as Therapy;
        setTherapyImage(updatedTherapy?.id, therapy.image, (url) => {
          setSelectedTherapy(null);
          getTherapies();
        });
      } else {
        setSelectedTherapy(null);
        getTherapies();
      }
    });
  };

  const handleDeleteTherapy = (therapyId: string) => {
    if (window.confirm("Are you sure you want to delete this therapy?")) {
      deleteTherapy(therapyId, () => {
        setSelectedTherapy(null);
        getTherapies();
      });
    }
  };

  const handleTherapySelection = (therapy?: Therapy) => {
    if (therapy) {
      getTherapyImage(therapy.id, (url) => {
        setSelectedTherapy({ ...therapy, imageURL: url });
      });
    } else {
      setSelectedTherapy({} as Therapy);
    }
  };

  if (loading || DMSServices.isLoading())
    return <LoadingBox message="Processing your request" />;

  if (selectedTherapy) {
    return (
      <TherapyDetails
        error={error || DMSServices.isError()}
        isLoading={loading || DMSServices.isLoading()}
        updateTherapy={handleUpdateTherapy}
        addTherapy={handleAddTherapy}
        deleteTherapy={handleDeleteTherapy}
        therapy={selectedTherapy}
        onCancelClick={() => {
          resetError();
          setSelectedTherapy(null);
        }}
      />
    );
  }

  return (
    <>
      <SimpleDataTable
        isLoading={loading || DMSServices.isLoading()}
        error={error}
        columns={THERAPIES_COLUMNS}
        data={therapies}
        title="Therapies"
        action={
          <Button onClick={() => handleTherapySelection()}>Add Therapy</Button>
        }
        onRowClick={handleTherapySelection}
      />
    </>
  );
};

export default Therapies;
